import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import { FontAwesomeIcon } from "./plugins/font-awesome";
import { Popover } from "ant-design-vue";
import { vMaska } from "maska";
import "ant-design-vue/dist/antd.css";

createApp(App)
  .use(store)
  .use(router)
  .use(Popover)
  .directive("maska", vMaska)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
